import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../api"
import type { ReferralLinkView } from "./ReferralLinkView"

export const generateReferralLinkRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, ReferralLinkView> = {
	buildUrl: () => "/referral",
	method: "get",
	path: "/referral",
}
